export default "__VITE_ASSET__CYizzzQP__"